export function getRandomInt(min: number, max: number): number {
  const minCeiled = Math.ceil(min);
  const maxFloored = Math.floor(max);
  return Math.floor(Math.random() * (maxFloored - minCeiled + 1) + minCeiled);
}

export const MAX_MOBILE_CARD_NUM = 2;
export const MAX_WIDGET_CARD_NUM = 3;
